import React from "react";
import { HeadFC, PageProps } from "gatsby";
import DefaultLayout from "../../layouts/default/default.layout";
import { Col, Container, Row } from "react-bootstrap";
import DefaultTitle from "../../layouts/default-title";
import Banner from "../../components/banner/banner.component";
import brewhouseImage from "./_index/assets/banner.jpg";
import Sidebar from "./_index/_sidebar";
import Facebook from "./_index/_facebook";

export const BrewHousePage: React.FC<PageProps> = () => {
    return (
        <DefaultLayout>
            <Banner backgroundImage={brewhouseImage} title="Genesee Brew House" subtitle="About" />
            <Container className="py-5">
                <Row>
                    <Col lg={9} className="pe-lg-5">
                        <h2 className="sans-serif fs-3 fw-bold lh-1 text-secondary mb-3">Once a Century-old Packaging Center</h2>
                        <p className="fs-5 lh-lg">
                            The Genesee Brew House has transformed the 9,200 square-foot space into a beer destination, featuring interactive exhibits, multimedia content, gift
                            shop, pilot brewery and pub-style restaurant. The Brew House was created to capture and share with you the long history of The Genesee Brewery - one of
                            the largest and oldest continually operating breweries in America. But the Brewery itself isn't half as interesting as the beer and the people who make
                            it.
                        </p>
                        <h2 className="sans-serif fs-3 fw-bold lh-1 text-secondary pt-3 my-3">Established in 2012</h2>
                        <p className="fs-5 lh-lg">
                            The Brew House and the building itself was in fact part of the original Genesee Brewery campus more than 100 years ago. We've taken this building and
                            transformed it into a special place that tells our story and the story of brewing beer in Rochester, New York.
                        </p>
                        <p className="fs-5 lh-lg">
                            We've dedicated the Brew House to the hardworking people who have brewed our iconic beers for generations. When you walk through our Brew House doors,
                            we hope you will get to know our brewers, learn how our beer is made and discover its history in every corner of our building. And while you're here, we
                            hope you enjoy a nice cold Genesee Beer with a friend or two and lift your glasses in celebration. Because that's what the Genesee Brew House is all
                            about.
                        </p>
                        <Facebook />
                    </Col>
                    <Col lg={3} className="mt-4 mt-lg-0">
                        <Sidebar />
                    </Col>
                </Row>
            </Container>
        </DefaultLayout>
    );
};

export default BrewHousePage;
export const Head: HeadFC = () => (
    <DefaultTitle
        title="Genesee Brew House"
        metaDescription="The Genesee Brew House is a beer destination, featuring interactive exhibits, multimedia content, gift shop, pilot brewery and pub-style restaurant inside a historic building that was part of the original Genesee Brewery campus more than 100 years ago."
    />
);
